import axios from "axios";

export const globalAxiosSetup = () => {
  axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL_V1;
  axios.defaults.headers.get.Accept = "application/json";
  axios.defaults.headers.post.Accept = "application/json";
};

const resolver = async ({
  url = "",
  method = "",
  params = undefined,
  data = undefined,
  requireAuthentication = true,
  headers = {},
}) => {
  const defaultBase = process.env.REACT_APP_SERVER_URL_V1;

  // Add base if url doesn't start with "http://" or "https://"
  const urlWithBase = /^https?:\/\//.test(url) ? url : `${defaultBase}${url}`;

  const authHeaders = {};
  const mandatoryHeaders = {
    "bludot-app-name": "business-rewards",
    "Content-Type": "application/json",
    Authorization: requireAuthentication
      ? `Bearer ${JSON.parse(localStorage.getItem("token") || "")}`
      : "",
  };
  const requestHeaders = { ...authHeaders, ...mandatoryHeaders, ...headers };
  const config = {
    method,
    params,
    headers: requestHeaders,
    data,
    url: `${urlWithBase}`,
    withCredentials: false,
  };

  try {
    const response: any = await axios.request(config);
    if (response.status >= 200 && response.status <= 209) {
      return { data: response.data };
    }

    return { error: response.data };
  } catch (err: any) {
    const status = err?.response?.status;
    const requestUrl = err?.response?.config?.url;
    return {
      error: {
        ...(err?.response?.data || {}),
        status,
        url: requestUrl,
      },
    };
  }
};

export interface IHTTPResponse<T = any> {
  data?: T;
  error?: any;
}

export const http = {
  get: async <T = any>(
    url: string,
    params: any = undefined,
    requireAuthentication: boolean = true
  ): Promise<IHTTPResponse<T>> =>
    resolver({ url, method: "GET", params, requireAuthentication }),

  post: async <T = any>(
    url: string,
    data: any,
    requireAuthentication: boolean = true,
    headers = {}
  ): Promise<IHTTPResponse<T>> =>
    resolver({ url, method: "POST", data, requireAuthentication, headers }),

  patch: async <T = any>(
    url: string,
    data: any,
    requireAuthentication: boolean = true,
    headers = {}
  ): Promise<IHTTPResponse<T>> =>
    resolver({ url, method: "PATCH", data, requireAuthentication, headers }),

  put: async <T = any>(
    url: string,
    data: any,
    requireAuthentication: boolean = true
  ): Promise<IHTTPResponse<T>> =>
    resolver({ url, method: "PUT", data, requireAuthentication }),

  delete: async <T = any>(
    url: string,
    requireAuthentication: boolean = true
  ): Promise<IHTTPResponse<T>> =>
    resolver({ url, method: "DELETE", requireAuthentication }),
};

export const API_CALL_METHODS = {
  GET: "get",
  POST: "post",
  PATCH: "patch",
};
